import { defineComponent as _defineComponent } from 'vue'
import { PropType, ref } from "vue";
import CalendarInput from "../shared/inputs/CalendarInput.vue";
import BoardHistoryRow from "./BoardHistoryRow.vue";
import EmptyContent from "../shared/EmptyContent.vue";
import { IBoardInfo } from "@/domain/entities/board";
import dayjs from "dayjs";
import ScrollTopControl from "../shared/ScrollTopControl.vue";


const __default__ = {
  name: "BoardHistoryTable",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  boardHistory: {
    type: Object as PropType<IBoardInfo[]>,
    required: true,
  },
  shouldShowEmptyContent: {
    type: Boolean,
    default: false,
  },
  searchFromDate: {
    type: String,
    default: dayjs().subtract(1, "month").format("YYYY-MM-DD"),
  },
  searchToDate: {
    type: String,
    default: dayjs().format("YYYY-MM-DD"),
  },
},
  emits: ["onClickFromDateInput", "onClickToDateInput", "onSelectBoardInfo"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();



const emit = __emit;

const boardHistoryContentArea = ref<HTMLElement>();

const emitOnClickFromDateInput = () => {
  emit("onClickFromDateInput");
};

const emitOnClickToDateInput = () => {
  emit("onClickToDateInput");
};

const emitOnSelectBoardInfo = (boardInfo: IBoardInfo) => {
  emit("onSelectBoardInfo", boardInfo);
};

const __returned__ = { emit, boardHistoryContentArea, emitOnClickFromDateInput, emitOnClickToDateInput, emitOnSelectBoardInfo, CalendarInput, BoardHistoryRow, EmptyContent, ScrollTopControl }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})